import { IFormValues } from './index';

export const formToValueSerializer = (values: IFormValues): FormData => {
  const formData = new FormData();
  const searchParams = new URLSearchParams(window?.location?.search);

  formData.append('utm_source', searchParams.get('utm_source') ?? '');
  formData.append('utm_medium', searchParams.get('utm_medium') ?? '');
  formData.append('utm_campaign', searchParams.get('utm_campaign') ?? '');

  formData.append('last_name', values?.secondName);
  formData.append('name', values?.firstName);
  formData.append('second_name', values?.patronymic);
  formData.append('phone', values?.phone);
  formData.append('email', values?.email);
  formData.append('connection', values?.variant);
  formData.append('connection', values?.variant);
  formData.append('connection', values?.variant);

  return formData;
};
